"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 29C8.89543 29 8 28.1046 8 27V13C8 11.8954 8.89543 11 10 11H30C31.1046 11 32 11.8954 32 13V27C32 28.1046 31.1046 29 30 29H10ZM11 14.1213V26H29V14.1213L21.4142 21.7071C20.6331 22.4882 19.3668 22.4882 18.5858 21.7071L11 14.1213ZM20 18.8787L15.6213 14.5H24.3787L20 18.8787Z", fill: colour }));
};
//# sourceMappingURL=Mail.js.map